import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from '../../../shared/services/data.service';
import { DeploymentTypeMetadata, DynamicOption } from '../models/deploymentForm.model';

@Injectable({
  providedIn: 'root',
})
export class FleetConfigurationService extends DataService<any> {

  httpClient: HttpClient;

  constructor(http: HttpClient) {
    super(`${environment.apiUrl.fleetConfigService}`, http);
    this.httpClient = http;
  }

  getConfigTemplates(): Observable<DeploymentTypeMetadata[]> {
    return this.http.get<DeploymentTypeMetadata[]>(`${this.url}`);
  }

  postConfigTemplate(templateDetails: any): Observable<any> {
    // return this.http.post( ${this.url}/${templateType}`, templateDetails);
    return this.http.post(`${this.url}`, JSON.stringify(templateDetails),
    {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }
  
  putConfigTemplate(templateDetails: any): Observable<any> {
    return this.http.put(`${this.url}`, JSON.stringify(templateDetails),
    {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }
  
  disableDevice(deviceId): Observable<any> {
    return this.http.post<any>(`${this.url}/${deviceId}/disable`, 
    {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  deprovisionDevice(deviceId) {
    return this.http.delete<any>(`${this.url}/${deviceId}`);
  }

  /**
   * Fetches dynamic options for a property whose optionsSource is "dynamic".
   * @param optionsEndpoint The relative endpoint path from the control metadata (e.g. "/devicemanagement/deployments/property-options/cisRelayAgentId").
   * @param parentValues A map of parent control names to their current values, sent as query parameters.
   * @returns Observable of DynamicOption array.
   */
  getDynamicPropertyOptions(optionsEndpoint: string, parentValues: Record<string, string>): Observable<DynamicOption[]> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(parentValues)) {
      if (value != null && value !== '') {
        params = params.set(key, value);
      }
    }
    // Build full URL: use the base URL root (strip the trailing path) + the relative options endpoint
    const baseUrl = this.url.substring(0, this.url.lastIndexOf('/'));
    return this.http.get<DynamicOption[]>(`${baseUrl}${optionsEndpoint}`, { params });
  }
}
